import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { helperTextEllipsis } from '../../helpers';
import { getRem } from '../../utils';
import { Colors } from '../../common/Colors';

export const SliderWrapper = styled('div')`
  background-color: ${Colors.rgbaInputRegular};
  height: 100%;
  position: relative;
  border-radius: 0.8rem;

  .noUi-base,
  .noUi-target,
  .noUi-connects {
    border-radius: 0.8rem;
  }

  .noUi-target {
    height: 100%;
    border: none;
    background-color: ${Colors.ut.border5};
    box-shadow: none;
    cursor: pointer;
  }

  .noUi-connect {
    background-color: ${Colors.blueLight50};
    border-radius: 0 0 0.8rem 0.8rem;
  }

  .noUi-connect {
    z-index: 2;
  }

  .noUi-marker {
    display: none;
  }

  .noUi-pips-horizontal {
    display: flex;
    justify-content: space-between;
    height: auto;
  }

  .noUi-value-horizontal {
    transform: none;
    color: ${Colors.black};
    position: static;
    opacity: 0.5;
  }

  .noUi-connects::after {
    content: '';
    background-color: #f0f2f5;
    top: 0;
    position: absolute;
    height: calc(100% - 0.5rem);
    width: 100%;
    z-index: 1;
  }

  .noUi-connect::before {
    content: '';
    background-color: #dde7f5;
    position: absolute;
    height: calc(100% - 0.5rem);
    width: 100%;
    z-index: 2;
  }

  .noUi-horizontal .noUi-origin {
    height: 100%;
  }

  .noUi-horizontal .noUi-handle {
    width: 2.2rem;
    height: 2.2rem;
    top: initial;
    bottom: -1rem;
    right: -1.1rem;
    cursor: pointer;
    border: none;
    outline: none;
    box-shadow: none;
    border-radius: 0.5rem;
    filter: drop-shadow(0px 0.3rem 1px rgba(0, 0, 0, 0.1))
      drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.16))
      drop-shadow(0px 0.3rem 0.8rem rgba(0, 0, 0, 0.15));
  }

  .noUi-handle::after {
    display: none;
  }

  .noUi-handle::before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    border-style: solid;
    border-width: 0 0.9rem 0.6rem 0.9rem;
    border-color: transparent transparent #ffffff;
    background-color: transparent;
  }
`;

interface ContainerProps {
  width?: number | string;
  height?: number | string;
  hasPips?: boolean;
}

export const Container = styled('div')<ContainerProps>`
  width: ${props => getRem(props.width) || '100%'};
  height: ${props => getRem(props.height) || '7.5rem'};
  padding-bottom: ${props => (props.hasPips ? '4.0rem' : '0')};
  box-sizing: initial;
  background-color: inherit;
`;

export const label = css`
  ${helperTextEllipsis};
`;

export const LabelLeft = styled('div')`
  ${label}
  float: left;
  margin-right: 0.5rem;
`;

export const LabelRight = styled('div')`
  ${label}
  float: right;
  margin-left: 0.5rem;
`;

export const SliderHead = styled('div')`
  margin-bottom: 0.5rem;
  line-height: 1.42;
  overflow: hidden;
  flex-wrap: nowrap;
`;

export const ChildrenElement = styled('div')`
  width: 100%;
  height: calc(100% - 1.5rem);
  overflow: hidden;
  position: absolute;
  z-index: 2;
`;
